import { TourConfig } from './types';

export const OITour: TourConfig = {
    id: 'oi-tour',
    name: 'OI Tour',
    description: 'Learn how to create and manage Operational Intelligence reports',
    steps: [
        {
            selector: 'body',
            content: (
                <div>
                    <h3 className="text-lg font-bold mb-2">Welcome to Operational Intelligence</h3>
                    <p>This tour will guide you through creating and managing OI reports.</p>
                    <p className="mt-2">Let's start by opening the OI drawer to see your reports.</p>
                </div>
            ),
            mobilePosition: 'center' as const,
            action: () => {
                const drawerControls = (window as any).oiDrawerControls;
                if (drawerControls && drawerControls.open) {
                    drawerControls.open();
                }
            },
            actionAfter: async () => {
                await new Promise(resolve => setTimeout(resolve, 500));
            },
        },
        {
            selector: '[data-tour="oi-create-button"]',
            content: (
                <div>
                    <h3 className="text-lg font-bold mb-2">Create New Report</h3>
                    <p>Click the "Add test" button to create a new report.</p>
                    <p className="mt-2">This will open the OI Form where you can fill in all the necessary details for your test report.</p>
                </div>
            ),
            position: 'right' as const,
            mobilePosition: 'center' as const,
        },
        {
            selector: '[data-tour="oi-drafts"]',
            content: (
                <div>
                    <h3 className="text-lg font-bold mb-2">Drafts Section</h3>
                    <p>All your draft reports are stored here.</p>
                    <p className="mt-2">Drafts are reports that you've started but haven't submitted yet. You can continue editing them at any time by clicking on them.</p>
                </div>
            ),
            position: 'right' as const,
            mobilePosition: 'center' as const,
        },
        {
            selector: '[data-tour="oi-completed"]',
            content: (
                <div>
                    <h3 className="text-lg font-bold mb-2">Completed Tests</h3>
                    <p>All your submitted reports appear here.</p>
                    <p className="mt-2">Once a report is submitted, it moves from Drafts to Completed. You can view, edit, clone, or delete these reports.</p>
                </div>
            ),
            position: 'right' as const,
            mobilePosition: 'center' as const,
        },
        {
            selector: '[data-tour="oi-form"]',
            content: (
                <div>
                    <h3 className="text-lg font-bold mb-2">OI Form</h3>
                    <p>The OI Form is where you create and edit your reports.</p>
                    <ul className="list-disc list-inside mt-2 space-y-1">
                        <li>Select the test type</li>
                        <li>Enter test ID and comments</li>
                        <li>Set start and end date/time</li>
                        <li>Add manufacturing comments</li>
                        <li>Tag elements and attach files</li>
                        <li>Select staff and DMC codes</li>
                    </ul>
                    <p className="mt-2"><strong>Save as Draft</strong> to continue later, or <strong>Submit</strong> to complete the report.</p>
                </div>
            ),
            position: 'left' as const,
            mobilePosition: 'center' as const,
            action: () => {
                const createButton = document.querySelector('[data-tour="oi-create-button"]') as HTMLButtonElement;
                if (createButton) {
                    createButton.click();
                }
            },
            actionAfter: async () => {
                await new Promise(resolve => setTimeout(resolve, 300));
            },
        },
    ],
};
